import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-header-body',
    templateUrl: './eui-card-header-body.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardHeaderBodyComponent {

    @HostBinding('class') string = 'eui-card-header-body';

    constructor() {
    }
}
